<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lHg2BT/tc-custom/9780226824925.jpg?1731180727084" alt="This image is the cover for the book Next Supercontinent"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Next Supercontinent
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An internationally recognized scientist shows that Earth’s separate continents, once together in Pangea, are again on a collision course.</b></p><p>You’ve heard of Pangea, the single landmass that broke apart some 175 million years ago to give us our current continents, but what about its predecessors, Rodinia or Columbia? These “supercontinents” from Earth’s past provide evidence that land repeatedly joins and separates. While scientists debate what that next supercontinent will look like—and what to name it—they all agree: one is coming.</p><p>In this engaging work, geophysicist Ross Mitchell invites readers to remote (and sometimes treacherous) lands for evidence of past supercontinents, delves into the phenomena that will birth the next, and presents the case for the future supercontinent of Amasia, defined by the merging of North America and Asia. Introducing readers to plate tectonic theory through fieldwork adventures and accessible scientific descriptions, Mitchell considers flows deep in the Earth’s mantle to explain Amasia’s future formation and shows how this developing theory can illuminate other planetary mysteries. He then poses the inevitable question: how can humanity survive the intervening 200 million years necessary to see Amasia?</p><p>An expert on the supercontinent cycle, Mitchell offers readers a front-row seat to a slow-motion mystery and an ongoing scientific debate.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ross Mitchell
      </h2>
      
      <p class="authorDescription body article"><B>Ross Mitchell</B> is professor at the Institute of Geology and Geophysics of the Chinese Academy of Sciences in Beijing. His supercontinent research has been covered by outlets including the <I>New York Times</I>, <I>Scientific American</I>, <I>NPR Science Friday</I>, and <I>Science</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ec5e88a4